module.exports = __webpack_public_path__ + "img/pick2.d6671810.png";